import { NgModule } from '@angular/core';
import { Routes, RouterModule, CanActivate } from '@angular/router';

import { AuthGuard } from './auth/auth.guard';

import { LoginComponent } from './login/login.component';
import { AuthWrapperComponent } from './auth-wrapper/auth-wrapper.component';

import { HomeComponent } from './home/home.component';
import { AdvisorsComponent } from './advisors/advisors.component';
import { ClientsComponent } from './clients/clients.component';
import { ApplicationsComponent } from './applications/applications.component';
import { OrganizationsComponent } from './organizations/organizations.component';
import { InfoCenterComponent } from './info-center/info-center.component';
import { ReportsComponent } from './reports/reports.component';
import { LegacyReportsComponent } from './legacy-reports/legacy-reports.component';
import { LeadsComponent } from './leads/leads.component';
import { CreateReportComponent } from './create-report/create-report.component';
import { ViewReportsComponent } from './view-reports/view-reports.component';
import { MarketingMaterialComponent } from './marketing-material/marketing-material.component';

import { CreateReportSelectionComponent } from './create-report-selection/create-report-selection.component';
import { SocialSecurityComponent } from './social-security/social-security.component';
import { MedicareMeansTestingComponent } from './medicare-means-testing/medicare-means-testing.component';
import { MedicareMeansTestingComponentV2 } from './medicare-means-testing-v2/medicare-means-testing-v2.component';
import { HealthCareComponent } from './healthcare/healthcare.component';
import { LongTermCareComponent } from './long-term-care/long-term-care.component';
import { AdminComponent } from './admin/admin.component';
//import { MetricsComponent } from './metrics/metrics.component';
import { MetricsComponentV2 } from './metrics-v2/metrics-v2.component';

import { ForgotPasswordComponent } from './forgot-password/forgotpassword.component';
import { RegisterComponent } from './register/register.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { ResetPasswordComponent } from './reset-password/resetpassword.component';

import { APP_BASE_HREF, HashLocationStrategy, LocationStrategy } from '@angular/common';

const routes: Routes = [
  {
    path: '', component: AuthWrapperComponent, canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', component: HomeComponent },
      { path: 'advisors', component: AdvisorsComponent },
      { path: 'clients', component: ClientsComponent },
      { path: 'leads', component: LeadsComponent },
      { path: 'admin', component: AdminComponent },
      { path: 'metrics', component: MetricsComponentV2 },
      //{ path: 'metricsv2', component: MetricsComponentV2 },
      { path: 'applications', component: ApplicationsComponent },
      { path: 'organizations', component: OrganizationsComponent },
      { path: 'info-center', component: InfoCenterComponent },
      { path: 'reports', component: ReportsComponent },
      { path: 'reports/create', component: CreateReportSelectionComponent },
      { path: 'reports/create/ss', component: SocialSecurityComponent, pathMatch: 'full' },
      { path: 'reports/create/mmt', component: MedicareMeansTestingComponent, pathMatch: 'full' },
      { path: 'reports/create/mmtv2', component: MedicareMeansTestingComponentV2, pathMatch: 'full' },
      { path: 'reports/create/ltc', component: LongTermCareComponent, pathMatch: 'full' },
      { path: 'reports/create/hc', component: HealthCareComponent, pathMatch: 'full' },
      { path: 'legacy-reports', component: LegacyReportsComponent, pathMatch: 'full' },
      { path: 'marketing-material', component: MarketingMaterialComponent }
    ]
  },
  { path: 'login', component: LoginComponent, pathMatch: 'full' },
  { path: 'register', component: RegisterComponent, pathMatch: 'full' },
  { path: 'sign-up', component: SignUpComponent, pathMatch: 'full' },
  { path: 'forgotPassword', component: ForgotPasswordComponent, pathMatch: 'full' },
  { path: 'resetPassword/:id', component: ResetPasswordComponent, pathMatch: 'full' },
  //{ path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [ {provide: LocationStrategy, useClass: HashLocationStrategy} ]
})
export class AppRoutingModule { }
